angular.module("digitalLeasing.module")
.component("beneInLeasingPl",{
    templateUrl: "ng/components/digitalLeasing/bancaPrestoLeasing/beneInLeasing/beneInLeasing.view.html",
    bindings:{
        model: '=',
        validateComponent:'&',
        callModuloInfo:'&',
        responseModuloNplInfo:'<'
    },
    controller: BeneInLeasing,
    controllerAs: "beneInLeasingPlCtrl"
})

function BeneInLeasing(
    $typeDomainService
){
    var self= this;

    self.$onInit = function(){
        popolatePagamentoFornitore();
        checkComponent();
    }

    self.$onChanges = function(changed){
        if(changed.responseModuloNplInfo && changed.responseModuloNplInfo.currentValue){
            if(!changed.responseModuloNplInfo.currentValue.showPagamentoFornitore){
                self.model.leasingData.preventivo.deliberaBanca.moduloInfoBanca.modalitaPagamentoFornitore="";
            }
            if(!changed.responseModuloNplInfo.currentValue.showAllestimento){
                self.model.leasingData.preventivo.deliberaBanca.moduloInfoBanca.inAllestimento= undefined;
            }

            self.model.leasingData.preventivo.deliberaBanca.moduloInfoBanca.stato = changed.responseModuloNplInfo.currentValue.statoBene;
        }
        checkComponent();
    }

    self.handleChange = function(property, value){
        if(property=='allestimento'){
            self.callModuloInfo();
        }else{
            self.model.leasingData.preventivo.deliberaBanca.moduloInfoBanca[property]= value;
        }
        checkComponent();
    }

    var popolatePagamentoFornitore= function(){
        $typeDomainService
          .getDomainSet("INFO_BANCA", "PAGAMENTO_FORNITORE")
          .then(function (response) {
              self.listOfAsk= response.domainList;
              console.log(response.domainList)
          })
    }

    var checkComponent = function(){
        var test = true;
        if(self.model.responseModuloNplInfo.showPagamentoFornitore){
            test = test && !!self.model.leasingData.preventivo.deliberaBanca.moduloInfoBanca.modalitaPagamentoFornitore
        }
        if(self.model.responseModuloNplInfo.showAllestimento){
            test = test && self.model.leasingData.preventivo.deliberaBanca.moduloInfoBanca.inAllestimento != undefined;
        }

        self.validateComponent({value: test})

    }

}